(function() {
  'use strict';

  angular.module('common')
    .directive('uniqueUserId', ['User', '$q', function(User, $q) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
          ngModel.$asyncValidators.uniqueUserId = (userId, newValue) => {
            var deferred = $q.defer();
            User.get({
              userId: userId
            }, (userInfo) => {
              if (userInfo.userId) {
                deferred.reject();
              } else {
                deferred.resolve();
              }
            });
            return deferred.promise;
          };
        }
      };
    }])
    .directive('uniqueEmailAddress', ['$http', '$q', function($http, $q) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, attrs, ngModel) {

          ngModel.$asyncValidators.uniqueEmailAddress = (email, newValue) => {
            var deferred = $q.defer();
            var userId = $scope.$eval(attrs.uniqueEmailId);
            var dsoId = $scope.$eval(attrs.uniqueEmailDsoId);
            var params = {
              email: email,
              dsoId: dsoId
            };
            if (userId !== undefined) {
              params.userId = userId;
            }
            $http.get('/uniqueEmailAddress', {params: params}).then((res) => {
              if (res.data) {
                deferred.resolve();
              } else {
                deferred.reject();
              }
            });
            return deferred.promise;
          };
        }
      };
    }])
    .directive('procedureCode', function() {
      var regex = /[^0-9]/g;
      var dString = /[^dD]/g;
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, attrs, ngModel) {
          element.attr('maxlength', 5);
          ngModel.$parsers.push(function(val) {
            if(!val) {
              return '';
            }
            var viewValue = '';
            if(dString.test(val.substring(0,1))) {
              if(regex.test(val.substring(0,1))) {
                viewValue = '';
              } else {
                viewValue = 'D' + val;
              }
            } else {
              if(val.length > 1) {
                val = val.substring(0,1) + val.substring(1).replace(regex, '');
              }

              viewValue = val;
            }
            val = viewValue;
            ngModel.$setViewValue(viewValue);
            ngModel.$render();
            //regex has coded in that checking the same string results in
            //skipping already checked characters so resetting here.
            regex.test("");
            dString.test("");
            return val;
          });
        }
      };
    })
    .directive('uniqueList', ['$filter', '$parse', function($filter, $parse) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, attrs, ngModel) {
          ngModel.$validators.uniqueList = (newEntry, viewValue) => {
            if (ngModel.$isEmpty(newEntry) || attrs.uniqueList === undefined) {
              return true;
            }
            var arrList = $parse(attrs.uniqueList)($scope);
            var expectedEntries =  $parse(attrs.modelCommitted)($scope) ? 1 :0;
            var filteredArr = _.filter(arrList,function(e){ return e===newEntry; });
            return (!(filteredArr && filteredArr.length > expectedEntries));
          };
        }
      };
    }])
    .directive('validPassword', ['$parse', function($parse) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, attrs, ngModel) {
          let data = {};
          let getter = $parse(attrs.validPassword);
          var isModelEmpty = function(newPassword) {
            return !data || ngModel.$isEmpty(newPassword);
          };
          $scope.$watch(() => {
            return getter($scope);
          }, function(val) {
            data = val;
            ngModel.$validate();
          }, true); //Deep watch on data
          ngModel.$validators.pswrdLength = (newPassword, viewValue) => {
            if (isModelEmpty(newPassword)) return true;
            return newPassword.length >= 7 && newPassword.length <= 32;
          };
          ngModel.$validators.pswrdAllowedChars = (newPassword, viewValue) => {
            if (isModelEmpty(newPassword)) return true;
            return /^[A-Za-z0-9]{1,32}$/.test(newPassword);
          };
          ngModel.$validators.pswrdReqdChars = (newPassword, viewValue) => {
            if (isModelEmpty(newPassword)) return true;
            return /^(?=.*\d)(?=.*[a-zA-Z]).{7,32}$/.test(newPassword);
          };
          ngModel.$validators.pswrdNameCheck = (newPassword, viewValue) => {
            if (isModelEmpty(newPassword)) return true;
            if (angular.debug && !(data.firstName && data.lastName)) {
              return true;
            }
            return data.firstName && data.lastName &&
              !_.includes(newPassword.toUpperCase(), data.firstName.toUpperCase()) &&
              !_.includes(newPassword.toUpperCase(), data.lastName.toUpperCase());
          };
          ngModel.$validators.pswrdSequentChars = (newPassword, viewValue) => {
            if (isModelEmpty(newPassword)) return true;
            return /^(?!.*(.)\1{2})/.test(newPassword);
          };
          ngModel.$validators.pswrdSimilarToOld = (newPassword, viewValue) => {
            if (isModelEmpty(newPassword) || !data.oldPassword) return true;
              return !((newPassword.substring(0, 4) == data.oldPassword.substring(0, 4))  ||
                       (newPassword.substring(newPassword.length - 4, newPassword.length) ==
                        data.oldPassword.substring(data.oldPassword.length - 4, data.oldPassword.length)));
          };
          ngModel.$validators.pswrdUserIdCheck = (newPassword, viewValue) => {
            if (isModelEmpty(newPassword)) return true;
            return data.userId &&
                  !_.includes(newPassword.toUpperCase(), data.userId.toUpperCase());
          };
        }
      };
    }])
    .directive('textMatch', ['$parse', function($parse) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, attrs, ngModel) {
          let other;
          let ignoreCase = attrs.ignoreCase === 'true';
          $scope.$watch(attrs.textMatch, function(val) {
            other = val;
            ngModel.$validate();
          });
          ngModel.$validators.textMatch = (modalValue, viewValue) => {
            if (ngModel.$isEmpty(modalValue) || !other) {
              return true;
            }
            return (modalValue === other) ||
              (ignoreCase && modalValue.toUpperCase() === other.toUpperCase());
          };
        }
      };
    }])
    .directive('emailTld', [function() {
      let pattern = /.+@.+\..+$/;
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function emailTldLink($scope, element, attrs, ngModel) {
          if (attrs.type !== 'email') {
            throw "This directive requires a input type of 'email'";
          }
          ngModel.$validators.emailTld = function validateEmailTld(val) {
            if (!val || ngModel.$error.email === true) {
              return true;
            }
            return val.match(pattern);
          };
        }
      };
    }]);
})();
